// assets
import { IconCertificate, IconFilePencil } from '@tabler/icons';

// constant
const icons = {
    IconCertificate,
    IconFilePencil
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const dataPages = {
    id: 'Data managment',
    title: 'Data managment',
    caption: 'manage all the events, skills, jobs',
    type: 'group',
    children: [
        {
            id: 'viewSkill',
            title: 'Speciality',
            type: 'item',
            url: '/skill/view',
            icon: icons.IconFilePencil
        },
        {
            id: 'viewEvents',
            title: 'Events',
            type: 'item',
            url: '/events/view',
            icon: icons.IconFilePencil
        },
        {
            id: 'viewJobs',
            title: 'Jobs',
            type: 'item',
            url: '/jobs/view',
            icon: icons.IconFilePencil
        },
        {
            id: 'viewPrompts',
            title: 'Prompts',
            type: 'item',
            url: '/prompts/view',
            icon: icons.IconFilePencil
        }
    ]
};
export default dataPages;
